{
  "en": {
    "map-objects": "Map Objects"
  },
  "fr": {
    "map-objects": "Objets"
  }
}